import { enUS, es } from 'date-fns/locale';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isValid } from 'date-fns';
import { useTheme } from '@mui/material';
import { Calendar } from 'lucide-react';

const localeMap: Record<string, any> = {
  es,
  en: enUS,
};

export const CustomDatePicker = ({
  name,
  onChange,
  value,
  inputProps,
  format,
  cancelLabel,
  okLabel,
}: {
  onChange: void | any;
  value: string | any;
  name?: string;
  inputProps?: string | any;
  format: string;
  cancelLabel?: string;
  okLabel?: string;
}): JSX.Element => {
  const theme = useTheme();
  const [currentDate, setCurrentDate] = useState(value !== '' ? value : null);
  const { i18n } = useTranslation();
  const language: string = i18n.language ? i18n.language : 'es';
  useEffect(() => {
    const date = new Date(value);
    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    if (typeof value === 'string' && !!value) {
      setCurrentDate(date);
    } else {
      setCurrentDate(value);
    }
  }, [value]);
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={localeMap[language]}
    >
      <DatePicker
        slots={{
          openPickerIcon: () => (
            <Calendar size={16} color={theme.palette.text.disabled} />
          ),
        }}
        maxDate={new Date()}
        format={format}
        value={isValid(currentDate) ? currentDate : undefined}
        onChange={(newDate: any) => onChange(name, newDate, false)}
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Inter, sans-serif',
            fontSize: theme.fontSizes.body,
            borderRadius: '14px',
            backgroundColor: 'white',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.divider,
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: `${theme.palette.primary.main}60`,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.primary.main,
              borderWidth: '1.5px',
            },
          },
        }}
        data-test-id="date-picker-dialog"
        slotProps={{
          textField: {
            ...inputProps,
          },
        }}
        localeText={{
          cancelButtonLabel: cancelLabel,
          okButtonLabel: okLabel,
          toolbarTitle: '',
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
